import { createSlice } from "@reduxjs/toolkit";
import { updateDoctorPatientCount } from "../../reducer/patientCount/updatePatientCountReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorPatientCountSlice = createSlice({
  name: "doctorPatientCount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDoctorPatientCount.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDoctorPatientCount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateDoctorPatientCount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorPatientCountSlice.reducer;
